import React from 'react'
import { translate } from 'react-i18next'
import Link, { withPrefix } from 'gatsby-link'
import { observer, inject } from 'mobx-react'

import IconCamera from '../../../static/svgs/icon-camera.svg'

import { Row, Column } from '../../global/grid/grid'
import { H2 } from '../../global/typography/typography'

import { CitiesWrapper, CitiesCompletedWrapper, CitiesUpcomingWrapper } from './styled-components'

const CitiesLists = translate()(inject('store')(observer(({ data, store, t, lng }) => {
  const gaCitySelected = (city, state) => {
    window.dataLayer.push({
      'event': 'cities-completed:select',
      'city': city + ',' + state
    })
  }

  return (
    <CitiesWrapper>
      <Row margins={[100, 100, 100]} id='cities-completed'>
        <Column cw={6}>
          <CitiesCompletedWrapper>
            <div className='title'>
              <H2 color={'blue'}>{t('citiesLists.completed.title')}</H2>
              <p><IconCamera /> = state with a story</p>
            </div>
            <Row style={{ marginTop: 0 }}>
              <Column cw={12}>
                <ul className='completed-cities__list'>
                  {
                    data.completed.cities.map((city, index) => (
                      city.link &&
                      <li key={index} className='completed-cities__item'>
                        <div className='cityAndState'>
                          <div className={`city ${city.link === store.csSlug ? 'current' : ''}`}>
                            <Link to={withPrefix(city.link)} onClick={() => { gaCitySelected(city.city, city.state) }}>
                              <IconCamera /> {city.city}
                            </Link>
                          </div>
                          <div className='state'>
                            <Link to={withPrefix(city.link)} onClick={() => { gaCitySelected(city.city, city.state) }}>
                              {city.state}
                            </Link>
                          </div>
                        </div>
                      </li>
                    ))
                  }

                  {
                    data.completed.cities.map((city, index) => (
                      !city.link &&
                      <li key={index} className='completed-cities__item'>
                        <div className='cityAndState'>
                          <div className='city'>
                            {city.city}
                          </div>
                          <div className='state'>
                            {city.state}
                          </div>
                        </div>
                      </li>
                    ))
                  }
                </ul>
              </Column>
            </Row>
          </CitiesCompletedWrapper>
        </Column>

        { data.upcoming.cities.length > 0 && 
          <Column cw={6}>
            <CitiesUpcomingWrapper lang={lng}>
              <div className='title'>
                <H2 color={'blue'} style={{ marginBottom: '5px' }}>{t('citiesLists.upcoming.title')}</H2>
              </div>
              <p className='teaser-text'>{t('citiesLists.upcoming.teaserText')}</p>
              <ul className='upcoming-cities__list'>
                {
                  data.upcoming.cities.map((city, index) => {
                    return (
                      <li key={index} className='upcoming-cities__item'>
                        <p className='cityAndState'>
                          <span className='city'>
                            {city.city}
                          </span>
                          <span className='state'>
                            {city.state}
                          </span>
                        </p>
                      </li>
                    )
                  })
                }
              </ul>
            </CitiesUpcomingWrapper>
          </Column>
        }
      </Row>
    </CitiesWrapper>
  )
})))

export default CitiesLists



// WEBPACK FOOTER //
// ./src/components/modules/CitiesLists/CitiesLists.js